export const commonLabelsCO = {
  missingDoc: 'Falta doc de',
  notValidate: 'No se puedo validar',
  cannotValidate: 'No se puede validar',
  modelPredictionMismatch: 'Predicción modelo',
  rejectedByRemo: 'Rechazado por calificación de Remo',
  patrimonyFamily:
    'Tiene patrimonio de familia y falta declaración sobre hijos menores',
};

const sameLabelAndValue = (text: string) => ({ label: text, value: text });

export const rejectReasonsCO = [
  {
    id: '1',
    label: `${commonLabelsCO.missingDoc} área construida`,
    value: 'Falta doc de area construida',
  },
  {
    id: '2',
    label: `${commonLabelsCO.missingDoc} garaje`,
    value: 'Falta doc de garaje',
  },
  {
    id: '3',
    ...sameLabelAndValue('Falta recibo admon'),
  },
  {
    id: '4',
    label: `${commonLabelsCO.missingDoc} área construida y garaje`,
    value: 'Falta doc de area construida y garaje',
  },
  { id: '5', label: 'Faltan docs legales', value: 'Faltan docs legales' },
  { id: '6', label: 'Por antigüedad', value: 'Por antiguedad' },
  {
    id: '7',
    label: 'Información errónea de remo en hubspot',
    value: 'Informacion erronea de remo en hubspot',
  },
  {
    id: '8',
    ...sameLabelAndValue('Vivienda no habi'),
  },
  {
    id: '9',
    ...sameLabelAndValue('Documentos incompletos'),
  },
  {
    id: '10',
    label: `${commonLabelsCO.notValidate} área`,
    value: 'No se puedo validar area',
  },
  {
    id: '11',
    label: `${commonLabelsCO.cannotValidate} antigüedad`,
    value: 'No se puede validar antigüedad',
  },
  {
    id: '12',
    label: `${commonLabelsCO.modelPredictionMismatch} área no coincide`,
    value: 'Prediccion modelo area no coincide',
  },
  {
    id: '13',
    label: commonLabelsCO.rejectedByRemo,
    value: commonLabelsCO.rejectedByRemo,
  },
  {
    id: '14',
    label: commonLabelsCO.patrimonyFamily,
    value: commonLabelsCO.patrimonyFamily,
  },
  {
    id: '15',
    ...sameLabelAndValue('Rechazo Leasing Banco Caja Social'),
  },
  {
    id: '16',
    ...sameLabelAndValue('Nid sin lote_id'),
  },
  {
    id: '17',
    ...sameLabelAndValue('No disponible para pricing por estado'),
  },
];
